<template>
    <div v-if="isDesktop" class="video-bg-container">
      <video autoplay loop muted playsinline src="@/assets/static/IMG_3379.mp4"></video>
    </div>
    <div class="app-container" :class="{ 'has-header': !$route.meta?.hideHeader }">
      <Header v-if="!$route.meta?.hideHeader"/>
      <router-view/>
      <TabBar v-if="!$route.meta?.hideTabBar"/>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import Header from './components/Header.vue'
import TabBar from './components/TabBar.vue'

export default {
  name: 'App',
  components: {
    Header,
    TabBar
  },
  setup() {
    const isDesktop = ref(window.innerWidth >= 768)

    const checkDesktop = () => {
      isDesktop.value = window.innerWidth >= 768
    }

    const mediaQuery = window.matchMedia('(min-width: 768px)')

    const handleMediaChange = (e) => {
      isDesktop.value = e.matches
    }

    onMounted(() => {
      checkDesktop()
      window.addEventListener('resize', checkDesktop)
      mediaQuery.addEventListener('change', handleMediaChange)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkDesktop)
      mediaQuery.removeEventListener('change', handleMediaChange)
    })

    return {
      isDesktop
    }
  }
}
</script>

<style>

.video-bg-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -2;
  overflow: hidden;
}

.video-bg-container video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%,-50%) scale(1.2);
  filter: blur(25px) brightness(.8);
  object-fit: cover;
}

.video-bg-container:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg,#d4a5744d,#b8860b4d);
  pointer-events: none;
}

.app-container {
  background-color: rgb(245, 247, 250);
}

.app-container.has-header {
  padding-top: 66px;
}

[data-theme="dark"] .app-container {
  background-color: var(--bg-primary);
}
</style>
